/* components/TabContainer.ts
This uses buttons to toggle content

Use within liquid as:
{! component 'TabContainer', titles: titleArray, contents: contentsArray, class: 'example-tab__container' !}

*/

import { Component, Ref, SimpleEvent, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '../../theme/ThemeComponent';
import { TabHeader } from '../../components/TabHeader/TabHeader';

import './TabContainer.scss';

@Component
export class TabContainer extends ThemeComponent {
    @Ref tabHeader!: TabHeader[];
    @Ref tabContent !: HTMLDivElement[];

    init() {
        this.$subscribe(this.tabHeader[0].onTabChange, this.tabChanged.bind(this));
    }
    private tabChanged(tab: string) {
        const container = this.tabHeader[0].closest('tab-container') as HTMLElement;
        const containerRefClass = container?.dataset?.refClass;
        const prevActiveButton = this.tabHeader[0].querySelector('.tab-header__button--active');
        if (prevActiveButton?.getAttribute('value') !== tab) {
            prevActiveButton?.classList.remove('tab-header__button--active');
            this.tabHeader[0].querySelector(`[value="${tab}"]`)?.classList.add('tab-header__button--active');
        }
        const prevActiveContent = [...this.querySelectorAll('.tab-content--active')];
        for (const tabContent of prevActiveContent) {
            if (tabContent instanceof HTMLElement) {
                if ((containerRefClass === tabContent?.dataset?.refClass) &&
                tabContent?.getAttribute('name') !== tab) {
                    tabContent?.classList.remove('tab-content--active');
                    for (const content of this.tabContent) {
                        if (content.getAttribute('name') === tab) {
                            content.classList.add('tab-content--active');
                        }
                    }
                }
            }
        }
    }
}
